import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './app/App';
import './index.css';

Sentry.init({
  dsn: 'https://9f45be9a55d7ec20804e5363ebadcd55@o4510883355492352.ingest.de.sentry.io/4510883360145488',
  sendDefaultPii: true,
  // Only enable in production
  enabled: import.meta.env.PROD,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
); 